import React, { useState, useContext, useEffect } from 'react';
import { ThemeContext } from 'styled-components';

import arrow from '@/images/general/scroll-arrow.svg';

import * as styled from './AdaptiveArrow.styled';

interface IAdaptiveArrow {
  elRef?: any;
  arrowVisibilityHeight?: number;
  $boxPaddingTop?: number;
  $boxPaddingTopMobile?: number;
  nextSectionPadding?: number;
  nextSectionPaddingMobile?: number;
}

export const AdaptiveArrow: React.FC<IAdaptiveArrow> = ({
  children,
  elRef,
  arrowVisibilityHeight = 900,
  $boxPaddingTop = 0,
  $boxPaddingTopMobile = 0,
  nextSectionPadding = 0,
  nextSectionPaddingMobile = 0,
}) => {
  const isBrowser = () => typeof window !== 'undefined';

  const windowInnerWidth = () => {
    if (isBrowser()) {
      return window.innerWidth;
    }
  };

  const theme = useContext(ThemeContext);

  const [arrowActive, setArrowActive] = useState(false);

  const paddingTop =
    windowInnerWidth() < theme.breakpoints.lg
      ? $boxPaddingTopMobile
      : $boxPaddingTop;

  const headerSize =
    windowInnerWidth() < theme.breakpoints.lg
      ? theme.headerSize.heightMobile
      : theme.headerSize.heightDesktop;

  const arrowBoxHeight = 68;

  useEffect(() => {
    const fuseOffset = 15;
    const maxHeight = arrowVisibilityHeight;
    const minHeight =
      elRef.current.offsetHeight +
      headerSize +
      arrowBoxHeight +
      fuseOffset -
      paddingTop;
    if (window.innerHeight <= maxHeight && window.innerHeight >= minHeight) {
      setArrowActive(true);
    }
  }, []);

  const onArrowClick = (element: HTMLElement) => {
    const prettyOfset = 30;
    const paddingBottom =
      windowInnerWidth() < theme.breakpoints.lg
        ? nextSectionPaddingMobile
        : nextSectionPadding;
    const y = element.offsetHeight + paddingTop + paddingBottom - prettyOfset;
    window.scrollTo({ top: y, behavior: 'smooth' });
    setArrowActive(false);
  };

  return (
    <styled.FullHeightContainer $arrowActive={arrowActive}>
      <styled.CenterContainer
        $arrowActive={arrowActive}
        $boxPaddingTop={$boxPaddingTop}
        $boxPaddingTopMobile={$boxPaddingTopMobile}
      >
        {children}
      </styled.CenterContainer>
      <styled.ArrowBox $arrowActive={arrowActive}>
        <styled.ArrowLink onClick={() => onArrowClick(elRef.current)}>
          <styled.Arrow src={arrow} />
        </styled.ArrowLink>
      </styled.ArrowBox>
    </styled.FullHeightContainer>
  );
};

export default AdaptiveArrow;
